module.exports = __webpack_public_path__ + "1fd90dbc.svg";